/**
 * List Routes
 */
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
// async components
import Lista from "./Lista";
import ProdutoCategoria from "./ProdutoCategoria";
// page title bar

const IndexPacote = ({ match, history }) => (
  <div className="content-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/lista`} />
      <Route path={`${match.url}/lista`} component={Lista} />
      <Route path={`${match.url}/:id`} component={ProdutoCategoria} />
    </Switch>
  </div>
);

export default IndexPacote;
